import { render, staticRenderFns } from "./ReservasActivasComponent.vue?vue&type=template&id=8820a0fe"
import script from "./ReservasActivasComponent.vue?vue&type=script&lang=js"
export * from "./ReservasActivasComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports